import SockJS from 'sockjs-client/dist/sockjs'
import Stomp from 'webstomp-client'
import settings from '../setttings'

export default {
  props: ['recording'],
  data () {
    return {
      backend_url: settings.VIDEO_EVENTS_URL,
      currentTime: 0,
      previousTime: 0,
      previousPlaybackRate: 1,
      init: 0
    }
  },
  mounted () {
    this.connect()
  },
  beforeDestroy () {
    this.disconnect()
  },
  watch: {
    player: function (player) {
      // cuando el player esté listo, comenzamos a escuchar los eventos
      if (player) {
        player.on('play', this.onEvent)
        player.on('pause', this.onEvent)
        player.on('seeked', this.onEvent)
        player.on('ratechange', this.onPlaybackRate)
        player.on('timeupdate', this.onTimeUpdate)
      }
    }
  },
  methods: {
    // WebSockets related methods
    connect () {
      const token = window.$cookies.get('LTI_JWT')
      this.socket = new SockJS(this.backend_url + '/event?token=' + token)
      this.stompClient = Stomp.over(this.socket)
      // importante para que no imprima un montón de logs
      this.stompClient.debug = () => {}
      this.stompClient.connect(
        {},
        frame => {
          // console.log('Connected: ' + frame+" -> token:"+token);
        },
        error => {
          console.log(error)
        }
      )
    },
    send (msg) {
      if (this.stompClient && this.stompClient.connected) {
        this.stompClient.send('/app/event', JSON.stringify(msg), {})
      }
    },
    disconnect () {
      if (this.stompClient) {
        this.stompClient.disconnect()
      }
    },

    // VideoJS related methods
    onEvent (e) {
      let playerSourceURL = new URL(this.player.currentSrc())
      playerSourceURL.search = ''
      playerSourceURL.hash = ''

      let msg = {
        'type': 'EVENT',
        'recordingId': this.recording.id,
        'init': this.init,
        'timestamp': Date.now()
      }
      switch (e.type) {
        case 'play':
          if (this.player.playbackRate() === 1) {
            this._saveInit()
          }
          break
        case 'pause':
          if (this.player.playbackRate() === 1) {
            this.send({
              ...msg,
              'end': (Math.abs(this.currentTime - this.previousTime) > 1) ? this.previousTime : this.currentTime
            })
          }
          break
        /* IMPORTANTE: el comportamiento de videoJS cuando se pulsa sobre la barra de desplazamiento cuando se está reproduciendo es:
            - pause
            - seeking (no controlado)
            - seeked
            - play

            Puesto que el seeking + seeked se lanzan con el reproductor en pause, no enviamos ningún evento al backend.
            Si este comportamiento cambia en el futuro, habrá que revisar esto y plantearse si es necesario capurar el evento seeking.
        */
        case 'seeked':
          if (this.player.playbackRate() === 1 && !this.player.paused()) {
            this.send({
              ...msg,
              'end': this.previousTime
            })
            this._saveInit()
          }
          break
        case 'ratechange':
          if (this.previousPlaybackRate === 1 && !this.player.paused()) {
            this.send({
              ...msg,
              'end': this.previousTime
            })
          }
          if (this.player.playbackRate() === 1) {
            this._saveInit()
          }
          break
      }
    },
    onPlaybackRate (e) {
      this.onEvent(e)
      this.previousPlaybackRate = this.player.playbackRate()
    },
    onTimeUpdate () {
      this.previousTime = this.currentTime
      // tiempo en milisegundos
      this.currentTime = Math.round(this.player.currentTime() * 1000)
    },
    _saveInit () {
      this.init = this.currentTime

      // enviamos al backend
      let playerSourceURL = new URL(this.player.currentSrc())
      playerSourceURL.search = ''
      playerSourceURL.hash = ''
      let msg = {
        'type': 'INIT',
        'recordingId': this.recording.id,
        'init': this.init,
        'timestamp': Date.now()
      }
      this.send(msg)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/videoEventsMixin.js